import type { ExcelDownloadClient } from "app/components/React/ExcelButton/ExcelClientDownload";
import ExcelClientDownload from "app/components/React/ExcelButton/ExcelClientDownload";
import { rerouteToSalesService } from "app/common/services/salesFetchService";

const salesApiRerouteDecorator = (excelClient: ExcelDownloadClient): ExcelDownloadClient => {
    return (url: string, body?: any, options: RequestInit = {}) => {
        const requestParams = rerouteToSalesService({ url, options });
        return excelClient(requestParams.url, body, requestParams.options);
    };
};

export const SalesIntelligenceExcelClient = salesApiRerouteDecorator(ExcelClientDownload);
